import { render, staticRenderFns } from "./documentsTabComponent.vue?vue&type=template&id=25253e42"
import script from "./documentsTabComponent.vue?vue&type=script&lang=js"
export * from "./documentsTabComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports